import { action } from "@ember/object"
import Component from "@glimmer/component"
import type { LegacyCardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import { tracked } from "tracked-built-ins"
import styles from "./lesson-menu-button.module.css"
interface Sig {
  Args: {
    course: Course
    courseDate: CourseDateCombined
    dateString: string
    editCourseTitleAndOrder: Function
    isNewLesson: boolean
    isNonInstructional: boolean
    lesson: LegacyCardStack
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    planbook: Planbook
    rotationCalendar: RotationCalendar
  }
}

export default class LessonMenuButton extends Component<Sig> {
  readonly styles = styles

  @tracked canShowLessonMenu = false

  @action
  toggleLessonMenu() {
    if (this.isDestroyed || this.isDestroying) return
    this.canShowLessonMenu = !this.canShowLessonMenu
  }

  @action
  closeMenu() {
    if (this.isDestroyed || this.isDestroying) return
    this.canShowLessonMenu = false
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Lesson::LessonMenuButton": typeof LessonMenuButton
  }
}
